import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IUser, IUserBackend, IUserFrontend } from '../../entity/User'
import { fetchUsers } from '../async-thunks/users/fetchUsers'
import { deleteUser } from '../async-thunks/users/deleteUser'
import { modifyUser } from '../async-thunks/users/modifyUser'
import { createNewUser } from '../async-thunks/users/createNewUser'

export interface IUserState {
    users: IUserBackend[]
    isLoading: boolean
    error: string | null | undefined
}

const initialState: IUserState = {
    users: [],
    isLoading: false,
    error: null,
}

const userSlice = createSlice({
    name: 'userSlice',
    initialState,
    reducers: {
        cancelFetchUsers: (state) => {
            state.isLoading = false
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.isLoading = false
                state.error = null
                state.users = action.payload
            })
            .addCase(fetchUsers.rejected, (state) => {
                state.isLoading = false // NOTE: was true before
                state.error = 'Fetching error'
                state.users = []
            })
            .addCase(
                deleteUser.fulfilled,
                (state, action: PayloadAction<{ login: string }>) => {
                    state.users = state.users.filter(
                        (user: IUser) => user.login !== action.payload.login
                    )
                }
            )
            .addCase(
                modifyUser.fulfilled,
                (state, action: PayloadAction<{ index: number, user: IUser }>) => {
                    state.users = state.users.map((user: any, i: number) => {
                        if (i === action.payload.index) {
                            return action.payload.user
                        }
                        return user
                    })
                }
            )
            .addCase(
                createNewUser.fulfilled,
                (state, action: PayloadAction<{ user: IUserFrontend }>) => {
                    state.users.push(action.payload.user)
                }
            )
    },
})

export const { actions: userActions } = userSlice
export const { reducer: userReducer } = userSlice
